import BaseModal from './BaseModal';
import { CourseStatus } from '../../interfaces/commons';
import { formatDate } from '../../libs/utils/formatters/datetimeFormatter';

export interface RecipientWithoutAccount {
  key: string;
  role: 'teacher' | 'participant';
  name: string;
  lessonTitle?: string;
  lessonDate?: string;
}

export interface RecipientsWithoutAccountWarning {
  status: CourseStatus;
  recipients: RecipientWithoutAccount[];
}

export const RECIPIENTS_WITHOUT_ACCOUNT_CODE = 'RECIPIENTS_WITHOUT_ACCOUNT';

/**
 * Estrae dall'errore di salvataggio del corso l'avviso sui destinatari
 * senza account, se è quello il motivo per cui il backend si è fermato
 */
export const getRecipientsWithoutAccountWarning = (
  err: any
): RecipientsWithoutAccountWarning | null => {
  const details = err?.response?.data?.error?.details;
  if (details?.code !== RECIPIENTS_WITHOUT_ACCOUNT_CODE) return null;
  return { status: details.status, recipients: details.recipients || [] };
};

interface Props {
  warning: RecipientsWithoutAccountWarning | null;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const getRecipientDescription = (recipient: RecipientWithoutAccount) => {
  if (recipient.role === 'participant') return ' - iscritto al corso';
  const lessonDate = recipient.lessonDate
    ? ` del ${formatDate(recipient.lessonDate, 'DD/MM/YYYY')}`
    : '';
  return ` - docente della lezione ${recipient.lessonTitle || ''}${lessonDate}`;
};

const RecipientsWithoutAccountModal: React.FC<Props> = ({
  warning,
  onCancel,
  onConfirm,
  isLoading,
}) => {
  const isCancellation = warning?.status === CourseStatus.CANCELED;

  return (
    <BaseModal
      title={isCancellation ? 'Annullamento corso' : 'Pubblicazione corso'}
      isOpen={!!warning}
      toggle={onCancel}
      className={'mx-auto md:w-[600px] w-11/12'}
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelButtonText='Annulla'
      confirmButtonText='Procedi comunque'
      isLoading={isLoading}
    >
      <>
        {isCancellation
          ? "Il corso non è ancora stato annullato. Le seguenti persone non hanno un account e non riceveranno l'avviso di annullamento:"
          : 'Il corso non è ancora stato pubblicato. I seguenti docenti non hanno un account e non riceveranno la notifica di pubblicazione:'}
        <ul className='mt-4 space-y-1 list-disc list-inside'>
          {warning?.recipients.map((recipient) => (
            <li key={recipient.key}>
              <strong>{recipient.name}</strong>
              {getRecipientDescription(recipient)}
            </li>
          ))}
        </ul>
      </>
    </BaseModal>
  );
};

export default RecipientsWithoutAccountModal;
